import React from 'react'
import './errorpage.scss'
import HeroSection from '../../components/Herosection/HeroSection'
import { Link } from 'react-router-dom'

const Errorpage = () => {
	return (
		<div className='main-wrapper errorpage-wrapper'>
			<HeroSection name={"404"} />
			<div className='section-wrapper'>
				<h2>Whoops!</h2>
				<h3>Diese Seite konnte nicht gefunden werden!</h3>
				<Link to={'/'} className='back-button'>Zurück zur Startseite</Link>
			</div>
		</div>
	)
}

export default Errorpage